import { render, staticRenderFns } from "./BlockDemo.vue?vue&type=template&id=20d39d6a&"
import script from "./BlockDemo.vue?vue&type=script&lang=js&"
export * from "./BlockDemo.vue?vue&type=script&lang=js&"
import style0 from "./BlockDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports